import ActionsCell from "./ActionsCell";

export const getColumns = (setSelectedCustomer, setOpenDeleteCustomer) => [
  {
    field: "sn",
    headerName: "SN",
    width: 80,
    sortable: false,
    filterable: false,
    renderCell: (params) => {
      const visibleSortedRows = params.api.getSortedRowIds?.();
      const index = visibleSortedRows?.indexOf(params.id);
      return index !== undefined ? index + 1 : "";
    },
  },
  {
    field: "customer_no",
    headerName: "Customer No",
    width: 200,
  },
  {
    field: "customer_name",
    headerName: "Customer name",
    width: 350,
  },
  {
    field: "created_at",
    headerName: "Created Date",
    width: 250,
  },
  {
    field: "created_by",
    headerName: "Created By",
    width: 200,
  },

  {
    field: "action",
    headerName: "Action",
    width: 300,
    sortable: false,
    renderCell: (params) => (
      <ActionsCell
        params={params}
        setSelectedCustomer={setSelectedCustomer}
        setOpenDeleteCustomer={setOpenDeleteCustomer}
      />
    ),
  },
];
